export const formatMoney = (value, formatString = 'fi-FI') => {
  const { format } = new Intl.NumberFormat(formatString, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  })
  return format(value)
}

export default formatMoney
